import { useRecoilValue } from "recoil";
// @mui
import { Stack, Button, Typography } from "@mui/material";
// routes
// atoms
import userAtom from "src/recoil/atoms/userAtom";
// assets
import { DocIllustration } from "../../../assets";
// hooks
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export default function NavbarDocs() {
  const user = useRecoilValue(userAtom);
  const { translate } = useLocales();

  return (
    <Stack
      spacing={3}
      sx={{
        px: 5,
        pb: 5,
        mt: 10,
        width: 1,
        textAlign: "center",
        display: "block",
      }}
    >
      <DocIllustration sx={{ width: 1 }} />

      <div>
        <Typography gutterBottom variant="subtitle1">
          {user?.first_name} {user?.last_name}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", whiteSpace: "pre-line" }}
        >
          {translate(
            "componentsTranslations.navBarTranslations.navBarDocs.description"
          )}
        </Typography>
      </div>

      <Button
        href={"https://basedontech.com"}
        target="_blank"
        rel="noopener"
        variant="contained"
      >
        {translate(
          "componentsTranslations.navBarTranslations.navBarDocs.actionButton"
        )}
      </Button>
    </Stack>
  );
}
